import React from "react";
import { Formik } from "formik";
import { Form } from "antd";
import { FormButtons, FormInputText, FormTextArea } from "components";
import { ValidationSchema } from "./ValidationSchema";
import FormCheckbox from "common/FormCheckbox";

export default function FrequentlyAskedQuestionForm({
  handleSubmitForm,
  initialValues,
  handleCancel,
}) {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={ValidationSchema}
      onSubmit={handleSubmitForm}
    >
      {({ handleSubmit, values }) => (
        <Form>
          <FormInputText
            placeholder="Título"
            name="ds_titulo"
            value={values.ds_titulo}
            required
          />
          <FormTextArea
            label="Descrição"
            name="ds_descricao"
            required
            value={values.ds_descricao}
          />
          <FormCheckbox label="Ativo" name="fg_ativo" value={values.fg_ativo} />
          <FormButtons
            bt2={{ label: "Salvar", onClick: handleSubmit }}
            bt1={{ label: "Cancelar", onClick: handleCancel }}
          />
        </Form>
      )}
    </Formik>
  );
}
